import AuthReducer from "./AuthReducer";
import { createContext, useEffect, useReducer } from "react";

const INITIAL_STATE = {
  user: JSON.parse(localStorage.getItem("user")) || 0,
  url:"https://tv1.yottalan.com",
  isFetching: false,
  error: "",
};

export const AuthContext = createContext(INITIAL_STATE);

export const AuthContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(AuthReducer, INITIAL_STATE);

  useEffect(() => {
    console.log("authcontext estado aquiiiiii");
    console.log(state.user);
    console.log(state.url);
    console.log("localstorage inicio");
    console.log(localStorage.getItem("user"));

      localStorage.setItem("user", JSON.stringify(state.user));
     

     console.log("estado del localstorage final");
     console.log(localStorage.getItem("user"));
  }, [state.user]);

  return (
    <AuthContext.Provider
      value={{                                                                                                                                                                                                                                                        
        user: state.user,
        url:state.url,
        isFetching: state.isFetching,
        error: state.error,
        dispatch,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
